import { Autocomplete } from "@/components/atoms";
import { useFilterJobs, useUserContext } from "@/providers/contexts";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useJobPostFilterOptions } from "@/hooks";

// Only available to premium users
export const CurrencyFilter = () => {
  const { disabledBasicContent, disabledProContent, isAuthenticated } =
    useUserContext();

  const { filters: jobPostFilters, loading: jobPostFiltersLoading } =
    useJobPostFilterOptions();
  const jobSalaryCurrencies = jobPostFilters?.jobSalaryCurrencies ?? [];

  const { filters, dispatch, loading } = useFilterJobs();
  const { selectedJobSalaryCurrencies } = filters;

  const disabledContent =
    disabledBasicContent || disabledProContent || !isAuthenticated;

  const mappedOptions: AutocompleteOption[] = jobSalaryCurrencies.map(
    option => ({
      key: option.id,
      value: option.currency_code,
      display: `${option.currency_code} (${option.currency_sign})`,
    }),
  );

  const selectedOption: AutocompleteOption | null =
    mappedOptions.find(opt => opt.key === selectedJobSalaryCurrencies[0]?.id) ??
    null;

  return (
    <Autocomplete
      componentName="currency"
      disabled={disabledContent}
      inputLabel="Currency"
      options={mappedOptions}
      value={selectedOption}
      onChange={(_, newValue) => {
        if (!newValue) {
          dispatch({
            type: "SET_FILTERS",
            payload: { selectedJobSalaryCurrencies: [] },
          });
          return;
        }
        const selectedOpt = newValue as AutocompleteOption | null;

        const selectedCurrency = jobSalaryCurrencies.find(
          c => c.id === selectedOpt?.key,
        );

        if (!selectedCurrency) return;

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedJobSalaryCurrencies: [selectedCurrency] },
        });
      }}
      loading={loading || jobPostFiltersLoading}
      tooltipMessage={
        disabledContent
          ? "Upgrade your account to access this feature"
          : undefined
      }
      readMoreLink="/memberships"
    />
  );
};
